<template>
  <el-container  style="display: block;">
    <el-row :span="2" style="margin-top: 30px;margin-left: 30px;">
        <el-col :span="2">名称:<el-input v-model="name" style="width: 150px;" placeholder="请输入名称"></el-input></el-col>
        <el-col :span="2">参数:<el-input v-model="canshu" style="width: 150px;" placeholder="请输入参数"></el-input></el-col>
        <el-col :span="2">
        <el-select v-model="typeName"  filterable placeholder="请选择" >
            <el-option
              v-for="item in typeArr"
              :key="item.name"
              :label="item.name"

              :value="item.value">
            </el-option>

          </el-select>
        </el-col>
        <el-col :span="2"><el-button type="primary" style="background-color: #409eff;margin-left: 50px;" @click="add()" round>添加</el-button></el-col>
    </el-row>
   <el-row :span="2" style="margin-left: 30px;margin-top: 30px;">
     <el-select v-model="typeNames"  filterable placeholder="请选择" >
         <el-option
           v-for="item in typeArr"
           :key="item.name"
           :label="item.name"

           :value="item.value">
         </el-option>

       </el-select>

     <el-button type="primary" style="background-color: #409eff;margin-left: 20px;" @click="loadData()" round>搜索</el-button>
   </el-row>

    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"

        height="1500"
        max-height="850"
        width='2780'
      	border
      	style="width: 2780px;height: 800px;text-align: center;margin: 0;">

        <el-table-column
          width="200"
          label="名字"
           >
           <template slot-scope="scope">
               <div>{{scope.row.name}}</div>



           </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="参数"
           >
           <template slot-scope="scope">
               <div>{{scope.row.canshu}}</div>


           </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="类别"
           >
           <template slot-scope="scope">
               <div v-if="scope.row.type == 1">发音人</div>
               <div v-if="scope.row.type == 2">拟人态</div>
               <div v-if="scope.row.type == 3">本体态</div>


           </template>
        </el-table-column>
        <el-table-column
          width="400"
          label="删除"
           >
           <template slot-scope="scope">
               <div  @click="doDell(scope.row.id)">删除</div>

           </template>
        </el-table-column>


        </el-table>
      </template>

    </el-row>


  </el-container>

</template>

<script>

  export default {
    data() {
       return {
        tableData:[],
        name:'',
        canshu:'',
        typeName:1,
        typeNames:1,
        typeArr:[{'name':'发音人','value':1},{'name':'本体态','value':3}]

      }
    },
	directives: {
    },
    created() {

      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();

    },

	methods:{
    doDell(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/fayinrenDel'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },

    add(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.name,
          canshu:this.canshu,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/fayinrenAdd'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          type:this.typeNames
    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/fayinrenList'
    	})
    	.then(res=>{
    		this.tableData = res.data.data;


    	})
    	.catch(err=>{

    	});
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
  .yuansushangxian{
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/fayinren.vue